import { render, staticRenderFns } from "./ExamineTable.vue?vue&type=template&id=3b8c2736&scoped=true"
import script from "./ExamineTable.vue?vue&type=script&lang=js"
export * from "./ExamineTable.vue?vue&type=script&lang=js"
import style0 from "./ExamineTable.vue?vue&type=style&index=0&id=3b8c2736&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.pnpm/vue-loader@15.11.1_nl733cueh6kngwrfuxx6f6mp5u/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b8c2736",
  null
  
)

export default component.exports